// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__DflBz","bannerBg":"styles_bannerBg__cDCFj","blackBox":"styles_blackBox__Jihfc"};